var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.003 23.885a1.5 1.5 0 1 1-2.006 2.23l-10-9a1.5 1.5 0 0 1 0-2.23l10-9a1.5 1.5 0 0 1 2.006 2.23L12.243 16l8.76 7.885z"}));
}

BackArrow.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
